const environment = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || 'development';

const config = Object.freeze({
  ENVIRONMENT: environment,
  IS_PRODUCTION: environment === 'production',
  IS_DEVELOPMENT: environment === 'development',
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REGION: process.env.REACT_APP_REGION,
  APPSYNC_BASE_URL: process.env.REACT_APP_APPSYNC_BASE_URL,
  WS_BASE_URL: process.env.REACT_APP_WS_BASE_URL,
  APP_NAME: process.env.REACT_APP_NAME || 'BotCircuits',
});

export default config;
